import ImageNotSupported from '@mui/icons-material/ImageNotSupportedOutlined'
import Avatar from '@mui/material/Avatar'
import { styled } from '@mui/material/styles'
import { colors } from 'styles/theme'

interface Props {
  iconUrl?: string
  size?: number
  altName?: string
  boxShadow?: string
}

const Icon = ({ iconUrl, size = 36, altName, boxShadow }: Props) => {
  return (
    <Avatar
      imgProps={{
        style: {
          borderRadius: size / 9,
          boxShadow: boxShadow ?? `0px 0px 0px 1px ${colors.gray[200]}`,
          width: `${size - 1}px`,
          height: `${size - 1}px`,
        },
        alt: altName,
      }}
      src={iconUrl}
      variant="square"
      style={{
        backgroundColor: 'transparent',
        color: colors.gray[400],
        width: size + 2,
        height: size + 2,
      }}
    >
      <NoIconWrapper size={size}>
        <ImageNotSupported sx={{ fontSize: `${size - size / 3}px` }} />
      </NoIconWrapper>
    </Avatar>
  )
}

export default Icon

const NoIconWrapper = styled('div')<{ size?: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  background-color: #fff;
  border-radius: ${({ size }) => size / 9}px;
  border: 1px solid ${colors.gray[400]};
`
